import { createContext } from "react";

export const PresentacionesContext = createContext()
export const PresentacionesFormContext = createContext()
export const PresentacionesReportContext = createContext()